import { Component, Input, OnInit } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { BehaviorSubject } from 'rxjs';
import { DashboardWidgetSlicer } from '../../dashboard-widget-base/dashboard-widget-base.component';

@Component({
    selector: 'tt-dashboard-slicer-widget-base',
    templateUrl: './dashboard-slicer-widget-base.component.html',
    styleUrls: ['./dashboard-slicer-widget-base.component.css'],
})
export class DashboardSlicerWidgetBaseComponent implements OnInit {
    /**
     * The configuration for the slicer widget.
     */
    @Input()
    ttSlicerWidget?: DashboardWidgetSlicer;

    /**
     * The slicer observable to update when the selection of the slicer has changed.
     */
    @Input()
    ttSlicerChanged?: BehaviorSubject<SlicerSubjectData[]>;

    /**
     * Loads data to the multi-select.
     */
    private async loadSlicerData() {
        if (!!this.ttSlicerWidget) {
            this.data = await this.datatask.Post(+this.ttSlicerWidget.p2_datatask_keyno, this.getDashboardContextParams());
        }
    }

    private getDashboardContextParams() {
        return this.ttSlicerWidget?.dashboardContext ? { ...this.ttSlicerWidget.dashboardContext } : {};
    }

    private markInitialAsSelected() {
        this.data = this.data.map((item: any) => {
            if (this.ttSlicerChanged?.value.map((slice) => ('' + slice.parameter_value).toLowerCase()).includes(('' + item[this.ttSlicerWidget!.data_id!]).toLowerCase())) {
                item['is_selected'] = '1';
            }

            return item;
        });
    }

    constructor(private datatask: DataTaskService) {}

    /**
     * List of items which can be selected.
     */
    public data: unknown[] = [];

    /**
     * Updates slicer observable when the selction has changed.
     *
     * @param event the ids which are currently selcted-
     */
    public onSelectChanged(event: string[]) {
        if (this.ttSlicerChanged) {
            let selected = this.ttSlicerChanged.value;
            selected = selected?.filter((item) => item.kpislicer_keyno !== this.ttSlicerWidget?.kpislicer_keyno);

            let newParameters: SlicerSubjectData[] = event.map((item) => ({ kpislicer_keyno: '' + this.ttSlicerWidget!.kpislicer_keyno, parameter_name: this.ttSlicerWidget!.parameter_name, parameter_value: item }));

            this.ttSlicerChanged.next([...selected, ...newParameters]);
        }
    }

    async ngOnInit(): Promise<void> {
        await this.loadSlicerData();
        this.markInitialAsSelected();
    }
}

export interface SlicerSubjectData {
    parameter_name: string;
    parameter_value: string;
    kpislicer_keyno: string;
}
